import React from 'react';
import styles from './formsBrowser.module.scss';
import { useTranslation } from 'react-i18next';
import { Form } from './Form';
import { FormProps, SearchProps, SelectionProps } from './types/FormTypes';

export const SearchResults = React.memo(
    (props: { selectionProps: SelectionProps; searchProps: SearchProps }) => {
        const { t } = useTranslation();

        try {
            const {
                selectionProps,
                searchProps: { searchResults },
            } = props;

            if (searchResults?.length) {
                return (
                    <div className={styles.formsGalleryViewContainer}>
                        <div className={styles.formsGalleryViewTitleContainer}>
                            {t('FormsBrowser.SearchResultsTitle')}
                        </div>
                        <div className={styles.formsGalleryViewSubContainer}>
                            {searchResults?.map((form: FormProps, index) => (
                                <div key={index}>
                                    <Form
                                        form={form}
                                        selectionProps={selectionProps}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                );
            } else {
                return (
                    <div className={styles.formsGalleryViewContainer}>
                        <div className={styles.formsGalleryViewTitleContainer}>
                            {t('FormsBrowser.SearchResultsTitle')}
                        </div>
                        <div>{t('FormsBrowser.SearchNoResults')}</div>
                    </div>
                );
            }
        } catch {
            return null;
        }
    },
);
